<div class="h-100">

	<readonly-access [readonly]="!dialogDataService.canEdit()"></readonly-access>

	<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="customHeight()"
		[rows]="dialogDataService.goalDetails()?.comments ?? []"></grid-content>
</div>